// routes/login.tsx
import { createFileRoute, redirect } from '@tanstack/react-router'
import * as v from 'valibot'

const SearchLoginSchema = v.object({
	to: v.string(),
})

export const Route = createFileRoute('/login')({
	component: Login,
	validateSearch: SearchLoginSchema,
	loaderDeps: ({ search: { to } }) => {
		return {
			to: to || '/',
		}
	},
	loader({ context, deps: { to } }) {
		const { auth } = context
		if (auth && !auth.isAuthenticated) {
			sessionStorage.setItem('return_to', to)
			auth.signinRedirect()
			return false
		}
		const returnTo = sessionStorage.getItem('return_to') || '/'
		if (returnTo) {
			sessionStorage.removeItem('return_to')
			throw redirect({ to: returnTo })
		}
		return true
	},
})

function Login() {
	const loaded = Route.useLoaderData()
	if (loaded === false) return null
	// Platzhalteransicht fuer den Login-Flow; der eigentliche Auth-Prozess laeuft ueber OIDC-Redirects.
	return <p>Angemeldet</p>
}
